module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "flashcards-study-application.1abcfa40.png" + "?" + Date.now();